import React, { useState } from 'react';
import { FaEnvelopeSquare, FaLock, FaUnlock } from 'react-icons/fa';
import { useRef } from 'react';
function App() {
  // 使用useState钩子来管理输入框的值和锁定状态
  const [inputValue, setInputValue] = useState('');
  const [isLocked, setIsLocked] = useState(true);
  const audioRef = useRef(null);
  const socketRef = useRef(null);
  const paly_state_Ref=useRef(true)
  const reconnectInterval = useRef(null);
  // 添加一个新的状态来控制按钮禁用
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  // 在文件顶部添加心跳相关的ref
  const heartbeatIntervalRef = useRef(null);
  const missedHeartbeatsRef = useRef(0);
  const MAX_MISSED_HEARTBEATS = 3;
  const MAX_RECONNECT_ATTEMPTS = 10;
  const reconnectAttemptsRef = useRef(0);
  const playAudio_end_confirmation_timeout = useRef(null);
  // 处理输入框变化的函数
  const handleChange = (event) => {
    if (!isLocked) {
      setInputValue(event.target.value);
      // 将输入值保存到localStorage中
      localStorage.setItem('savedInput', event.target.value);
    }
  };

  // 切换锁定状态
  const toggleLock = () => {
    setIsLocked(!isLocked);
  };


  const connectWebSocket = () => {

    const newSocket = new WebSocket("ws://192.168.1.6:8000/ws");
    // const newSocket = new WebSocket("ws://192.168.31.249:8000/ws");
    // 心跳检测函数
    const startHeartbeat = () => {
      // 清除可能存在的旧心跳
      if (heartbeatIntervalRef.current) {
        clearInterval(heartbeatIntervalRef.current);
      }
      
      missedHeartbeatsRef.current = 0;
      
      heartbeatIntervalRef.current = setInterval(() => {
        if (socketRef.current?.readyState === WebSocket.OPEN) {
          console.log("发送心跳");
          socketRef.current.send(JSON.stringify({ 'type': "ping" ,'content':''}));
          missedHeartbeatsRef.current++;
          
          if (missedHeartbeatsRef.current >= MAX_MISSED_HEARTBEATS) {
            console.warn("心跳超时，重新连接");
            socketRef.current.close();
          }
        }
      }, 8000); // 每8秒发送一次心跳
    };

    newSocket.onopen = () => {
      console.log("WebSocket连接已建立");
      if (reconnectInterval.current) {
        clearInterval(reconnectInterval.current);
        reconnectInterval.current = null;
      }
      setIsButtonDisabled(true);
      
      // 启动心跳检测
      startHeartbeat();
      
      const t = JSON.stringify({ 'type': "post_SplitTTSIdentifier", 'content': inputValue });
      console.log("发送请求:", t);
      socketRef.current.send(t);
    };

    newSocket.onmessage = (event) => {
      const data_dict = JSON.parse(event.data);
      
      // 处理心跳响应
      if (data_dict.type === "pong") {
        console.log("收到心跳")
        missedHeartbeatsRef.current = 0;
        return;
      } 
      else if (data_dict.type === "play_audio") {
        paly_state_Ref.current=true
        console.log("播放音频:", data_dict.content);
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.src = '';
          audioRef.current = null;
        }
        const audio = new Audio(data_dict.content);
        audio.volume = 1;

        audio.addEventListener('ended', () => {
          if(paly_state_Ref.current===false){
            return;
          }
          const t = JSON.stringify({ 'type': "playAudio_end", 'content': inputValue });
          console.log("发送请求:", t);
          socketRef.current.send(t);
          if (playAudio_end_confirmation_timeout.current) {
            clearInterval(playAudio_end_confirmation_timeout.current);
            playAudio_end_confirmation_timeout.current = null;
          }
          // 设置5秒超时
          playAudio_end_confirmation_timeout.current = setInterval(() => {
            if(paly_state_Ref.current===false){
              return;
            }
            console.error("音频播放结束未收到确认消息 从新发送playAudio_end");
            const t = JSON.stringify({ 'type': "playAudio_end", 'content': inputValue });
            console.log("发送请求:", t);
            socketRef.current.send(t);
          }, 5000);
        });

        audioRef.current = audio;
        audio.play().catch(error => {
          console.error("音频播放失败:", error);
        });
      }
      else if (data_dict.type === "playAudio_end_confirmation") {
        console.log("音频播放结束确认已接收:", data_dict.content);
        clearInterval(playAudio_end_confirmation_timeout.current);
        playAudio_end_confirmation_timeout.current = null;
        return;
      }
      // 处理音频消息
      else if(data_dict.type ==="stop_playAudio"){
        console.log("暂停播放")
        paly_state_Ref.current=false
        audioRef.current.pause()
        if(playAudio_end_confirmation_timeout.current){
          clearInterval(playAudio_end_confirmation_timeout.current);
          playAudio_end_confirmation_timeout.current = null;
        }

      }
    };

    newSocket.onclose = (event) => {
      console.log("WebSocket连接已关闭,关闭码:", event.code);
      console.log("关闭原因:", event.reason);
      setIsButtonDisabled(false);
      
      // 清理心跳定时器
      if (heartbeatIntervalRef.current) {
        clearInterval(heartbeatIntervalRef.current);
        heartbeatIntervalRef.current = null;
      }
      
      // 尝试重连
      if (reconnectAttemptsRef.current >= MAX_RECONNECT_ATTEMPTS) {
        console.log("达到最大重连次数，停止重连");
        clearInterval(reconnectInterval.current);
        reconnectInterval.current = null;
        return;
      }
      reconnectAttemptsRef.current++;
      if (reconnectInterval.current===null) {
      reconnectInterval.current = setInterval(() => {
        console.log("尝试重新连接WebSocket...");
          connectWebSocket();
        }, 5000);
      }
    };

    socketRef.current = newSocket;
  };

  // 组件加载时从localStorage读取保存的值
  React.useEffect(() => {
    const savedValue = localStorage.getItem('savedInput');
    if (savedValue) {
      setInputValue(savedValue);
    }

    return () => {
      // 清理WebSocket
      if (socketRef.current) {
        socketRef.current.close();
        socketRef.current = null;
      }
      // 清理定时器
      if (reconnectInterval.current) {
        clearInterval(reconnectInterval.current);
        reconnectInterval.current = null;
      }
      if (heartbeatIntervalRef.current) {
        clearInterval(heartbeatIntervalRef.current);
        heartbeatIntervalRef.current = null;
      }
      // 清理音频
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = '';
        audioRef.current = null;
      }
      // 重置所有计数器
      missedHeartbeatsRef.current = 0;
      reconnectAttemptsRef.current = 0;
    };
  }, []);

  const btn_on_click = () => {
    connectWebSocket();
  }

  return (
    <div className="App">
      <header className="App-header">
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          height: '100vh',
          backgroundColor: '#f0f8ff'
        }}>
          <h1 style={{
            color: '#0066cc',
            textShadow: '2px 2px 4px rgba(0,0,0,0.1)'
          }}>TTS唯一标识</h1>
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <input
              type="text"
              value={inputValue}
              onChange={handleChange}
              placeholder="TTS唯一标识"
              disabled={isLocked}
              style={{ 
                margin: '20px 0',
                padding: '10px 15px',
                paddingRight: '40px',
                borderRadius: '5px',
                border: `2px solid ${isLocked ? '#cccccc' : '#4d94ff'}`,
                outline: 'none',
                fontSize: '16px',
                width: '300px',
                boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                transition: 'all 0.3s ease',
                backgroundColor: isLocked ? '#f5f5f5' : 'white',
                ':focus': {
                  borderColor: '#0052cc',
                  boxShadow: '0 0 8px rgba(0,102,204,0.5)'
                }
              }}
            />
            <div 
              onClick={toggleLock}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                color: isLocked ? '#666' : '#4d94ff'
              }}
            >
              {isLocked ? <FaLock /> : <FaUnlock />}
            </div>
          </div>
          <button 
            onClick={btn_on_click}
            disabled={isButtonDisabled}
            style={{
              marginTop: '20px',
              padding: '15px 25px', 
              borderRadius: '5px',
              border: 'none',
              backgroundColor: isButtonDisabled ? '#cccccc' : '#4d94ff', // 添加禁用状态的样式
              color: 'white',
              fontSize: '48px',
              cursor: isButtonDisabled ? 'not-allowed' : 'pointer', // 添加禁用状态的光标样式
              boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
              transition: 'background-color 0.3s ease'
            }}
          >
            {isButtonDisabled ? '已连接...' : '连接发送标识'}
          </button>
        </div>
      </header>
    </div>
  );
}

export default App;